import http from "@/utils/http";

export interface GetAISummarizeParamsProps {
  map_prompt: string;
  combine_prompt: string;
  filename: string;
}

export interface GetAISummarizeDataProps {
  text: string;
}

export const getAISummarize = (params: GetAISummarizeParamsProps): Promise<GetAISummarizeDataProps> => {
  return http({
    url: '/api/v1/ai/summarize',
    method: 'POST',
    data: params,
    transformRequest: [
      function (data: GetAISummarizeParamsProps): string {
        let ret = '';
        for (const it in data) {
          // 如果 data[it] 是一个对象, 需要先使用 JSON.stringify, 再使用 encode
          ret += `${encodeURIComponent(it)  }=${  encodeURIComponent(data[it])  }&`;
        }
        ret = ret.substring(0, ret.lastIndexOf('&'));
        return ret;
      }
    ],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }) as Promise<GetAISummarizeDataProps>;
};
